import { Background } from './Background';
import { StartScreen } from './StartScreen';
import { GameScreen } from './GameScreen';
import { CUSTOM_EVENTS } from '../cfg/constants/game-constants';
export class GameComponents {
    constructor(scene) {
        this.scene = scene;
        this.isGameRunning = false;
        this.currentHitTimerEnded = true;
        this.background = new Background(this.scene);
        this.startScreen = new StartScreen(this.scene);
        this.GameScreen = new GameScreen(this.scene);
        this.addEventHandlers();
    }
    addEventHandlers() {
        this.scene.globalEvents.on(CUSTOM_EVENTS.SET_GAMESCREEN1, () => {
            this.GameScreen.updateGameScreen(1);
        });
        this.scene.globalEvents.on(CUSTOM_EVENTS.SET_GAMESCREEN2, () => {
            this.GameScreen.updateGameScreen(2);
        });
        this.scene.globalEvents.on(CUSTOM_EVENTS.SET_GAMESCREEN3, () => {
            this.GameScreen.updateGameScreen(3);
        });
    }
    setupGame(cells) { }
    startGame() {
        this.isGameRunning = true;
    }
    endGame() {
        this.isGameRunning = false;
    }
    gameCleanUp() {
        //
    }
    resizeAndRepositionElements(w, h) {
        this.background.resizeAndRepositionElements(w, h);
    }
    update(delta) { }
}
